import UserCommission, {
  UserCommissionsFormSend,
} from "@/interfaces/UserCommission";
import api from "../api";

export const userCommissionsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserCommissions: build.query<UserCommission[], string>({
      query: (id) => `/users/${id}/commissions`,
      providesTags: (_result, _error, id) => [{ type: "UserCommissions", id }],
    }),
    updateUserCommissions: build.mutation<
      UserCommission[],
      [string, UserCommissionsFormSend]
    >({
      query: ([id, body]) => ({
        url: `/users/${id}/commissions`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, [id]) => [
        { type: "UserCommissions", id },
      ],
    }),
  }),
  overrideExisting: true,
});

export const { useGetUserCommissionsQuery, useUpdateUserCommissionsMutation } =
  userCommissionsApi;
